import React from 'react';
import { IonModal } from '@ionic/react';
import CiaLoginModalContent from './CiaLoginModalContent';

export default function CiaLoginModalTrigger(props) {
    const { showModal, setShowModal } = props;

    const onCloseHandler = () => setShowModal(false);

    React.useLayoutEffect(() => {
        setTimeout(() => setShowModal(true), 1200);
    }, [setShowModal]);

    return (
        <div className="cia-login-modal-trigger py-1">
            <IonModal cssClass="cia-login-modal-trigger" mode="md" isOpen={showModal} onDidDismiss={onCloseHandler}>
                <CiaLoginModalContent closerHandler={onCloseHandler}></CiaLoginModalContent>
            </IonModal>
        </div>
    );
}
